module.exports = __webpack_public_path__ + "img/white-logo-cn-express.5fa6ba0.png";